import { render, staticRenderFns } from "./AvailabilityHub.vue?vue&type=template&id=4e72c6aa"
import script from "./AvailabilityHub.vue?vue&type=script&lang=js"
export * from "./AvailabilityHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e72c6aa')) {
      api.createRecord('4e72c6aa', component.options)
    } else {
      api.reload('4e72c6aa', component.options)
    }
    module.hot.accept("./AvailabilityHub.vue?vue&type=template&id=4e72c6aa", function () {
      api.rerender('4e72c6aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/AvailabilityHub.vue"
export default component.exports